import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';

const PageNumber = ({ page, activePage }) => (
    <li className={`page-item ${activePage + 1 === page && 'active'}`}>
        <Link className="page-link" to={`${page}`}>{page}</Link>
    </li>
);

PageNumber.propTypes = {
    page: PropTypes.number.isRequired,
    activePage: PropTypes.number.isRequired,
};

// TODO Translation
const PreviousPage = ({ page }) => (
    <li className={`page-item ${page === 0 && 'disabled'}`}>
        <Link className="page-link" aria-label="Previous" to={`${page}`}>
            <span aria-hidden="true">&laquo;</span>
            <span className="sr-only">Previous</span>
        </Link>
    </li>
);
PreviousPage.propTypes = {
    page: PropTypes.number.isRequired,
};

// TODO Translation
const NextPage = ({ page, maxPage }) => (
    <li className={`page-item ${page + 1 >= maxPage && 'disabled'}`}>
        <Link className="page-link" aria-label="Next" to={`${page + 1 + 1}`}>
            <span aria-hidden="true">&raquo;</span>
            <span className="sr-only">Next</span>
        </Link>
    </li>
);
NextPage.propTypes = {
    page: PropTypes.number.isRequired,
    maxPage: PropTypes.number.isRequired,
};

const TablePagination = ({ store }) => {
    const pageItems = [];
    for (let i = Math.max(1, store.page - 1); i <= Math.min(store.page + 3, store.totalPageCount); i += 1) {
        pageItems.push(<PageNumber page={i} activePage={store.page} key={i.toString()} />);
    }
    return (
        <nav aria-label="Page navigation">
            <ul className="pagination justify-content-center">
                <PreviousPage page={store.page} key="previous" />
                {pageItems}
                <NextPage page={store.page} maxPage={store.totalPageCount} key="next" />
            </ul>
        </nav>);
};


TablePagination.propTypes = {
    store: PropTypes.object.isRequired,
};

export default (observer(TablePagination));
